<template>
  <div>
      <v-alert v-if="showAlert" density="compact" :type="alertType" @click="showAlert = false">
        <template v-slot:title>
          {{ alertTitle }}
        </template>
        {{ alertText }}
        <v-btn icon @click="Logout()">
          Sair
      </v-btn>
      </v-alert>
      <v-alert v-if="showAlert2" density="compact" :type="alertType2" @click="showAlert2 = false">
        <template v-slot:title>
          {{ alertTitle2 }}
        </template>
        {{ alertText2 }}
      </v-alert>
    <div class="container" v-if="User != ''">
      <div class="page-inner">
        <div class="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
          <div>
            <h3 class="fw-bold mb-3">Olá {{ User.nome }}</h3> 
          </div>
        </div>
        <div class="row" v-if="User.tipo == 0">
          <div class="col-sm-8 col-md-8">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="card card-stats card-round">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-icon">
                        <div class="icon-big text-center icon-primary bubble-shadow-small">
                          <i class="fas fa-users"></i>
                        </div>
                      </div>
                      <div class="col col-stats ms-3 ms-sm-0">
                        <div class="numbers">
                          <p class="card-category">Garantidoras Cadastradas</p>
                          <h4 class="card-title">{{ ListGarantidorasGeral }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6" v-if="User.tusid != 3">
                <div class="card card-stats card-round">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-icon">
                        <div class="icon-big text-center icon-info bubble-shadow-small">
                          <i class="fas fa-user-check"></i>
                        </div>
                      </div>
                      <div class="col col-stats ms-3 ms-sm-0">
                        <div class="numbers">
                          <p class="card-category">Contratações Vigentes</p>
                          <h4 class="card-title">{{ ListPedidosGeral.length }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6" v-if="User.tusid != 3">
                <div class="card card-stats card-round">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-icon">
                        <div class="icon-big text-center icon-success bubble-shadow-small">
                          <i class="fas fa-luggage-cart"></i>
                        </div>
                      </div>
                      <div class="col col-stats ms-3 ms-sm-0">
                        <div class="numbers">
                          <p class="card-category">Contratações Atendimento</p>
                          <h4 class="card-title">{{ ListPedidosAtendimento.length }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6" v-if="User.tusid != 3">
                <div class="card card-stats card-round">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-icon">
                        <div class="icon-big text-center icon-secondary bubble-shadow-small">
                          <i class="far fa-check-circle"></i>
                        </div>
                      </div>
                      <div class="col col-stats ms-3 ms-sm-0">
                        <div class="numbers">
                          <p class="card-category">Contratações Negadas</p>
                          <h4 class="card-title">{{ ListPedidosNegados.length }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-md-4">
             <div class="card card-black card-round">
              <div class="card-header">
                <div class="card-head-row">
                  <div class="card-title">Controle de Usos ({{ $moment().format('MMMM[/]YYYY') }})</div>
                </div>
              </div>
              <div class="card-body">
                <!-- Pesquisas de Crédito -->
                <div class="card-category">Pesquisas de Crédito</div>
                <div class="d-flex align-items-center justify-content-between mt-2 mb-4">
                  <h6 class="m-0">Total Usados {{ ListPedidosPesquisados }}</h6>
                  <button class="btn btn-sm btn-info" style="background-color: #ffffff; color: #000000;display: none;">
                    Visualizar
                  </button>
                </div>
                <!-- Assinaturas Digitais -->
                <div class="card-category">Assinaturas Digitais</div>
                <div class="d-flex align-items-center justify-content-between mt-2 mb-4">
                  <h6 class="m-0">Total Usados {{ ListPedidosAssinados }}</h6>
                  <button class="btn btn-sm btn-info" style="background-color: #ffffff; color: #000000;display: none;">
                    Visualizar
                  </button>
                </div>
              </div>
            </div>
         </div>
         
        </div>
         <div class="row" v-if="User.tipo == 1 && User.tusid != 3">
          <div class="col-sm-8 col-md-8">
             <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="card card-stats card-round">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-icon">
                        <div class="icon-big text-center icon-primary bubble-shadow-small">
                          <i class="fas fa-users"></i>
                        </div>
                      </div>
                      <div class="col col-stats ms-3 ms-sm-0">
                        <div class="numbers">
                          <p class="card-category">Imobiliarias Cadastradas</p>
                          <h4 class="card-title">{{ ListImobiliariasGeral }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="card card-stats card-round">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-icon">
                        <div class="icon-big text-center icon-info bubble-shadow-small">
                          <i class="fas fa-user-check"></i>
                        </div>
                      </div>
                      <div class="col col-stats ms-3 ms-sm-0">
                        <div class="numbers">
                          <p class="card-category">Contratações Vigentes</p>
                          <h4 class="card-title">{{ ListPedidosGeral.length }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="card card-stats card-round">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-icon">
                        <div class="icon-big text-center icon-success bubble-shadow-small">
                          <i class="fas fa-luggage-cart"></i>
                        </div>
                      </div>
                      <div class="col col-stats ms-3 ms-sm-0">
                        <div class="numbers">
                          <p class="card-category">Contratações Atendimento</p>
                          <h4 class="card-title">{{ ListPedidosAtendimento.length }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="card card-stats card-round">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-icon">
                        <div class="icon-big text-center icon-secondary bubble-shadow-small">
                          <i class="far fa-check-circle"></i>
                        </div>
                      </div>
                      <div class="col col-stats ms-3 ms-sm-0">
                        <div class="numbers">
                          <p class="card-category">Contratações Negadas</p>
                          <h4 class="card-title">{{ ListPedidosNegados.length }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                </div>
          </div>
          <div class="col-sm-4 col-md-4">
            <div class="card card-black card-round" v-if="PlanoGarantidora!=''" >
              <div class="card-header">
                <div class="card-head-row">
                  <div class="card-title">Controle de Usos ({{ $moment().format('MMMM[/]YYYY') }})</div>
                </div>
              </div>
              <div class="card-body">
                <h3>Plano: {{  PlanoGarantidora  }}</h3>
                <!-- Pesquisas de Crédito -->
                <div class="card-category">Pesquisas de Crédito</div>
                <div class="d-flex align-items-center justify-content-between mt-2 mb-4">
                  <h6 class="m-0">Usados {{ ListPedidosPesquisados }} de {{ totalCpc2 }}</h6>
                  <router-link v-if="User.menu.filter(x=> x.cdtid == 29).length > 0" to="/RecargaConsultas" class="btn btn-sm btn-info" style="background-color: #ffffff; color: #000000;">
                    Contratar
                  </router-link>
                </div>
                <!-- Assinaturas Digitais -->
                <div class="card-category">Assinaturas Digitais</div>
                <div class="d-flex align-items-center justify-content-between mt-2 mb-4">
                  <h6 class="m-0">Usados {{ ListPedidosAssinados }} de {{ totalCpc1 }}</h6>
                  <router-link v-if="User.menu.filter(x=> x.cdtid == 29).length > 0" to="/RecargaConsultas" class="btn btn-sm btn-info" style="background-color: #ffffff; color: #000000;">
                    Contratar
                  </router-link>
                </div>
              </div>
            </div>
          </div>        
        </div>
        <div class="row" v-if="User.tipo != 3 && User.tusid != 3">
          <div class="col-md-12">
            <div class="card card-round">
              <div class="card-header">
                <div class="card-head-row card-tools-still-right" style="display: inline-flex;">
                  <div class="card-title">Contratações em andamento</div>
                </div>
              </div>
              <div class="card-body">
                <easy-data-table :headers="headers" :items="ListPedidosAtendimento" v-model="itemsSelected" alternating
                  theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                  body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                  <template #item-pedDataPedido="item">
                    <span> {{ item.pedDataPedido !== null ? formattedDate(item.pedDataPedido) : null }}</span>
                  </template>
                  <template #item-pedValorTotalPedido="item">
                    {{ item.pedValorTotalPedido !== null ? formatarValor(item.pedValorTotalPedido) : 0 }}
                  </template>
                  <template #item-pedSituacaoPedido="item">
                      <button
                          class="btn status-btn"
                          :class="statusClass(item.pspId)"
                          @click="EditGrid(item)"
                      >
                          {{ item.pedSituacaoPedido }}
                      </button>
                  </template>
                </easy-data-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '../auth/oidc';

export default {
  name: 'HomeView',
  components: {
  },
  data: () => ({
    accordion: false,
    User: [],
    ListaMeusContratos: [],
    libera: [],
    showAlert: false, // Controle de visibilidade do alerta
    alertTitle: "", // Título do alerta
    alertText: "", // Texto do alerta
    alertType: "", // Tipo do alerta (success, warning, error, etc.)
    //
    showAlert2: false, // Controle de visibilidade do alerta
    alertTitle2: "", // Título do alerta
    alertText2: "", // Texto do alerta
    alertType2: "warning", // Tipo do alerta (success, warning, error, etc.)
    //dashboard
    ListGarantidorasGeral: 0,
    ListPedidosGeral: [],
    ListPedidosAtendimento: [],
    ListPedidosNegados: [],
    ListPedidosPesquisados: [],
    ListPedidosAssinados: [],
    headers: [],
    searchValue: '',
    ListImobiliariasGeral:0,
    PlanoGarantidora:'',
    totalCpc1:0,
    totalCpc2:0,
    itemsSelected: [],
    ConfiguraSinistroGar: [],
      situacoesMenu: [          
            { id: 1, label: "Aguardando Análise" },
            { id: 2, label: "Análise Manual" },
            { id: 8, label: "Aguardando Documentos" },
            { id: 14, label: "Processando Análise de Crédito" },
            { id: 15, label: "Gerar Contrato" },
            { id: 13, label: "Preparando Envio Assinatura" },
            { id: 9, label: "Aguardando Assinatura" },
            { id: 5, label: "Aprovado Gerar Cobrança" },
            { id: 7, label: "Aguardando Pagamento" },
            { id: 0, label: "Todos" },
            ]
  }),
  methods: {
     statusClass(pspId) {
            const map = {
            8:  "btn-warning",     // mantém (warning)
            9:  "btn-dark",        // mantém (black)
            7:  "btn-info",
            2:  "btn-secondary",
            1:  "btn-primary",
            5:  "btn-orange",      // custom
            13: "btn-purple",      // custom
            14: "btn-teal",        // custom
            15: "btn-pink"         // custom
            };

            return map[pspId] || "btn-light";
        },
    formattedDate(value) {
      return this.$moment(value).format('DD/MM/YYYY')
    },
    async Logout() {
      await authService.signOutRedirect()
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      );
    },
    preprocessData(data) {
      return data.map(item => {
        return {
          ...item,
          proOrdem: parseInt(item.proOrdem),
        };
      });
    },
    formattedDate(value) {
      if (value != null || value != "") {
        return this.$moment(value).format('DD/MM/YYYY')
      }
      else {
        return "";
      }

    },
    formatarValor(valor) {
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    },
    montaGrid() {
      this.headers = [];
      this.headers.push({ text: "Id", value: "pedId", sortable: true, });
      this.headers.push({ text: "Data", value: "pedDataPedido", sortable: true, });
      if (this.User.tipo == 0) {
        this.headers.push({ text: "Garantidora", value: "garNome", sortable: true, });
      }
      if (this.User.tipo != 3) {
        this.headers.push({ text: "Imobiliaria", value: "imobNome", sortable: true, });
      }
      this.headers.push({ text: "Cliente", value: "cliNome", sortable: true, });
      this.headers.push({ text: "Valor", value: "pedValorTotalPedido", sortable: true, });
      this.headers.push({ text: "Situação", value: "pedSituacaoPedido", sortable: true, });
    },
    EditGrid(item) {
      this.$router.push('/contratacaodetalhe/' + item.pedId);
    },
  },
  async created() {

    await axios.get(`/Telas/Home/GetDados`)
      .then(response => {
         console.log('response')
              console.log(response)
        if (response.data.bloqueioGarantidora){
             localStorage.removeItem('_useravgar');
             this.$router.push('/')
        }
        else if (response.data.validaContratosGar.length > 0){
            this.alertTitle = "Assinatura Pendente";
            this.alertText = "Identificamos assinatura de contrato pendente, verifique seu e-mail ou entre em contato com suporte GarantePay.";
            this.alertType = "warning";
            this.showAlert = true;
        }
        else if (response.data.validaContratosImo.length > 0){
            this.alertTitle = "Assinatura Pendente";
            this.alertText = "Identificamos assinatura de contrato pendente, verifique seu e-mail ou entre em contato com suporte da sua Garantidora.";
            this.alertType = "warning";
            this.showAlert = true;
        }
        else{
          let _mostraAlert2 = false;
           let _validaConfigSinistroGar = response.data.garantidoraConfigSinistro;
               if ((_validaConfigSinistroGar == null || _validaConfigSinistroGar == '') && response.data.tipo != 0){
                    _mostraAlert2 = true;
                }
                else if (_validaConfigSinistroGar != '' && _validaConfigSinistroGar != null && response.data.tipo != 0){
                    if (_validaConfigSinistroGar[0].gscEmailAprovacao === '' || _validaConfigSinistroGar[0].gscEmailAprovacao === null) {
                             _mostraAlert2 = true;
                        }
                        else if (_validaConfigSinistroGar[0].gscEmailPagamento === '' || _validaConfigSinistroGar[0].gscEmailPagamento === null ) {
                             _mostraAlert2 = true;
                        }
                        else if (_validaConfigSinistroGar[0].gscEmailCobranca === '' || _validaConfigSinistroGar[0].gscEmailCobranca === null) {
                            _mostraAlert2 = true;
                        }
                        else if (_validaConfigSinistroGar[0].gscEmailFinanceiro === '' || _validaConfigSinistroGar[0].gscEmailFinanceiro === null) {
                             _mostraAlert2 = true;
                        }
                        else if (_validaConfigSinistroGar[0].gscEmailJuridico === '' || _validaConfigSinistroGar[0].gscEmailJuridico === null) {
                             _mostraAlert2 = true;
                        }
                        else if (_validaConfigSinistroGar[0].gscMulta === '' || _validaConfigSinistroGar[0].gscMulta === null) {
                            _mostraAlert2 = true;
                        }
                        else if (_validaConfigSinistroGar[0].gscJuroDiario === '' || _validaConfigSinistroGar[0].gscJuroDiario === null) {
                             _mostraAlert2 = true;
                        }
                }

                if (_mostraAlert2){
                    this.alertTitle2 = "Cadastro Pendente";
                    this.alertText2 = "Identificamos que dados de configuração de Sinistro, na Tela Garantidora (aba Sinistro) devem ser preenchidos. " + (response.data.tipo == 3 ? " Contate sua Garantidora" : "");
                    this.alertType2 = "warning";
                    this.showAlert2 = true;
                }

              let _dadoUser = {
                  nome: response.data.userNome,
                  urlimage: response.data.userImagem,
                  garlogo:  response.data.garLogo,
                  tipo: response.data.tipo,
                  tusid: response.data.tusId,
                  menu: response.data.menu
              }
                localStorage.setItem('_useravgar', JSON.stringify(_dadoUser));

               this.ListGarantidorasGeral = response.data.garCount
               this.ListPedidosPesquisados = response.data.validaConsultas.totalConsultasRealizadas;
               this.ListPedidosAssinados =  response.data.validaConsultas.totalAssinaturasRealizadas;
               this.totalCpc1 = response.data.validaConsultas.totalAssinaturas;
               this.totalCpc2 = response.data.validaConsultas.totalConsultas;
               this.ListPedidosGeral = response.data.listaPedidos.filter(x=> x.pspId == 3);   
               this.ListPedidosAtendimento = response.data.listaPedidos.filter(x=> x.pspId != 6  && x.pspId != 3 && x.pspId != 4);     
               this.ListPedidosNegados = response.data.listaPedidos.filter(x=> x.pspId == 6 || x.pspId == 4); 
               this.User = _dadoUser;
               this.PlanoGarantidora =  response.data.planoGarantidora;
               this.montaGrid();
               window.dispatchEvent(new CustomEvent('menu:updated'));
        }

      });
  },
}
</script>

<style>

 .status-btn{
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 6px;
  border: 0;
  margin: 3px;
}

/* mantém warning e dark do bootstrap */

/* cores custom (todas diferentes) */
.btn-orange { background:#ff7a00; color:#fff; }
.btn-purple { background:#6f42c1; color:#fff; }
.btn-teal   { background:#20c997; color:#fff; }
.btn-pink   { background:#e83e8c; color:#fff; }

/* se usar btn-light como fallback */
.btn-light { background:#f1f3f5; color:#212529; }

</style>
